(function () {
  const revealBlocks = [];
  const TRIGGER_LINE_RATIO = 0.55; // 55% de la hauteur d'écran depuis le haut
  let ticking = false;

  function wrapWords(el) {
    const startColor = el.dataset.colorStart || '#52525C';
    const endColor = el.dataset.colorEnd || '#F2F1ED';
    const text = el.textContent.trim();
    const words = text.split(/\s+/);

    el.innerHTML = words
      .map(function (word) {
        return '<span class="md-word" style="color:' + startColor + ';">' + word + '</span>';
      })
      .join(' ');

    return {
      startColor: startColor,
      endColor: endColor,
      words: Array.prototype.slice.call(el.querySelectorAll('.md-word')),
    };
  }

  function updateColors() {
    const triggerY = window.innerHeight * TRIGGER_LINE_RATIO;

    revealBlocks.forEach(function (block) {
      block.words.forEach(function (word) {
        const rect = word.getBoundingClientRect();
        const wordCenter = rect.top + rect.height / 2;
        word.style.color = wordCenter < triggerY ? block.endColor : block.startColor;
      });
    });

    ticking = false;
  }

  function requestUpdate() {
    if (!ticking) {
      window.requestAnimationFrame(updateColors);
      ticking = true;
    }
  }

  function init() {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    document.querySelectorAll('.md-scroll-reveal').forEach(function (el) {
      const block = wrapWords(el);

      if (reducedMotion) {
        block.words.forEach(function (word) {
          word.style.color = block.endColor;
        });
        return;
      }

      revealBlocks.push(block);
    });

    if (revealBlocks.length === 0) return;

    updateColors();
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();